import { Visibility as ViewIcon } from "@mui/icons-material";
import { Chip, IconButton, Tooltip } from "@mui/material";

import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import EllipsisText from "../../../../components/EllipsisText";

export const createTestEventsColumns = ({
    dispatchGetTestEventDetail,
    setEventDetailsModal,
}) => [
    {
        key: "date",
        header: "Date",
        render: (row) => (
            <EllipsisText
                text={row.event_time}
                width="120px"
                controlMobile={true}
            />
        ),
    },
    {
        key: "event_name",
        header: "Event Name",
        render: (row) => (
            <EllipsisText
                text={row.event_name}
                width="150px"
                controlMobile={true}
            />
        ),
    },
    {
        key: "pixel_id",
        header: "Pixel ID",
        render: (row) => (
            <EllipsisText
                text={row.pixel_id}
                width="120px"
                controlMobile={true}
            />
        ),
    },
    {
        key: "event_received",
        header: "Event Received",
        render: (row) => (row.event_received ? "Yes" : ""),
    },
    {
        key: "event_sent",
        header: "Event Sent",
        render: (row) => (row.event_sent ? "Yes" : ""),
    },
    {
        key: "status",
        header: "Status",
        render: (row) => (
            <>
                {row.status === "error" && (
                    <Chip
                        icon={<FontAwesomeIcon icon={faTimes} />}
                        label="Error"
                        color="error"
                        variant="filled"
                        size="small"
                        onClick={() => {}}
                    />
                )}
                {row.status === "processed" && (
                    <Chip
                        icon={<FontAwesomeIcon icon={faCheck} />}
                        label="Processed"
                        color="primary"
                        variant="filled"
                        size="small"
                        onClick={() => {}}
                    />
                )}
                {row.status === "success" && (
                    <Chip
                        icon={<FontAwesomeIcon icon={faCheck} />}
                        label="Success"
                        color="success"
                        variant="filled"
                        size="small"
                        onClick={() => {}}
                    />
                )}
            </>
        ),
    },
    {
        key: "action",
        header: "Action",
        render: (row) => (
            <Tooltip
                title="View detailed information about this test event including payload data, timestamps, and processing status"
                arrow
                placement="top"
            >
                <IconButton
                    color="default"
                    size="small"
                    onClick={() => {
                        dispatchGetTestEventDetail(row?.id);
                        setEventDetailsModal(true);
                    }}
                >
                    <ViewIcon />
                </IconButton>
            </Tooltip>
        ),
    },
];

export const createRequestsColumns = () => [
    {
        key: "date",
        header: "Date",
        render: (row) => <EllipsisText text={row.event_time} width="120px" />,
    },
    {
        key: "event_name",
        header: "Event Name",
        render: (row) => <EllipsisText text={row.event_name} width="150px" />,
    },
    {
        key: "ip",
        header: "IP",
        render: (row) => <EllipsisText text={row.ip} width="120px" />,
    },
];
